
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 3101","fill":"currentColor"}},[_c('path',{attrs:{"data-name":"Rectangle 1628","d":"M6.057 11.281h11.886v1.437H6.057z"}}),_c('path',{attrs:{"data-name":"Path 2210","d":"M12 18.663a5.054 5.054 0 01-4.6-2.407l1.292-.628a3.675 3.675 0 003.306 1.6c1.875 0 3.462-1.03 3.462-2.253a1.479 1.479 0 00-.161-.668l1.287-.639a2.879 2.879 0 01.311 1.308c0 2.07-2.15 3.69-4.9 3.69"}}),_c('path',{attrs:{"data-name":"Path 2211","d":"M12 12.719c-2.7 0-4.9-1.654-4.9-3.69s2.195-3.69 4.9-3.69a5.05 5.05 0 014.609 2.414l-1.3.624a3.665 3.665 0 00-3.31-1.6c-1.875 0-3.46 1.03-3.46 2.251s1.585 2.253 3.46 2.253z"}})])])
          )
        }
      }
    